import {
  ChatBubbleLeftRightIcon,
  ChatBubbleLeftIcon,
  Cog6ToothIcon,
  ShoppingBagIcon,
  ClockIcon,
  MapPinIcon
} from '@heroicons/react/24/outline';
import { t } from '../i18n';

export const profileModules = [
  { id: 'orders', title: t('my_orders'), path: '/profile/my-orders', icon: ShoppingBagIcon },
  { id: 'interactions', title: t('my_interactions'), path: '/profile/my-interactions', icon: ChatBubbleLeftRightIcon },
  { id: 'comments', title: t('my_comments'), path: '/profile/my-comments', icon: ChatBubbleLeftIcon },
  { id: 'address-management', title: t('address_management'), path: '/profile/address-management', icon: MapPinIcon },
  { id: 'membership-history', title: t('membership_history'), path: '/profile/membership-history', icon: ClockIcon },
  { id: 'settings', title: t('account_settings'), path: '/profile/account-settings', icon: Cog6ToothIcon }
];

export function matchProfileModule(item, pathname) {
  return pathname === item.path || pathname.startsWith(`${item.path}/`);
}
